module.exports = __webpack_public_path__ + "img/Acc-3.2758f6b5.jpg";